import { render, staticRenderFns } from "./FrkServerError.vue?vue&type=template&id=70e64878&"
import script from "./FrkServerError.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FrkServerError.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports